export default __webpack_public_path__ + "static/media/rock.8f6c5c5a.svg";